<template>
  <div style="background:#e0e0e0">
    <!-- 混合轮播 -->
    <div style="background:#10131e" ref="bgColor">
      <mySwiper />
    </div>
    <!-- 产品 -->
    <productBanner />

    <!-- 关于我们 -->
    <div class="Showtitle p-2" style="background:#fff">
      <h1 class=" " style="color:#000">{{ $t("Home.aboutUs") }}</h1>
      <div class="Titleline"></div>
    </div>

    <section class="Home-main A-us" style="width:100%;height:auto">
      <div class="home-shadow"></div>
      <div class="proHomecontainer " style="position:relative">
        <div class="corp-desc  " style="color: #ffffff;">
          <h2 class="corp-title">
            浙江帕尼尔工具有限公司
          </h2>

          <a class="learn-more" href="/Desc">查看更多</a>
        </div>
      </div>
    </section>

    <div
      class=" newstec"
      style="background:linear-gradient(to right, #666666 30%,#ffffff 120%);"
    >
      <div class="newstechcontainer">
        <div class="Showtitle" style="padding-top:30px">
          <h1 class="">{{ $t("Home.newsTitle") }}</h1>
          <div class="Titleline"></div>
        </div>
        <!-- <img src="../../static/images/newsBanner.png" alt=""> -->

        <div style="margin:30px 0;margin-bottom:0">
          <b-row class="news-row">
            <b-col class="col-md-6 left-newspic" style="">
              <div style="margin-top: 0;margin-bottom: 0;">
                <b-img :src="newsBanner.src" fluid style="width: 100%;"></b-img>
              </div>
            </b-col>

            <b-col
              class=" col-md-6"
              style="margin-top: 0;margin-bottom: 10px;color: #000;padding-left:5px;margin-left:0;"
            >
              <div class="news-title">
                <h4 style="text-align:left">新闻</h4>
              </div>
              <div v-for="(item, newsindex) in news" :key="newsindex">
                <b-row class="col-sm-6 news-list-item" style="max-width:100%">
                  <b-col class="techlist-item">
                    <div class="news-item-time">
                      <span class="news-item-day">
                        {{ item.day }}
                      </span>
                      <span class="news-item-month">
                        {{ item.ym }}
                      </span>
                    </div>
                    <div class="news-item-text">
                      <a
                        :href="'/newsdetail/'.concat(item.newsId)"
                        class="news-item-title"
                      >
                        {{ item.newsTitle }}</a
                      >
                      <div class="news-item-content">
                        <p style="margin:0 0 10px">{{ item.newsContent }}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-row class="tech-row">
            <b-col
              class=" col-md-6"
              style="margin-top: 0;margin-bottom: 10px;color: #000;padding-left:0;margin-left:0;padding-top:10px"
            >
              <div class="news-title">
                <h4 style="text-align:left">技术</h4>
              </div>
              <div v-for="(item, tecindex) in tech" :key="tecindex">
                <b-row class="col-sm-6 news-list-item" style="max-width:100%">
                  <b-col class="newslist-item">
                    <div class="news-item-time">
                      <span class="news-item-day">
                        {{ item.day }}
                      </span>
                      <span class="news-item-month">
                        {{ item.ym }}
                      </span>
                    </div>
                    <div class="news-item-text">
                      <a
                        :href="'/techdetail/'.concat(item.tecId)"
                        class="news-item-title"
                      >
                        {{ item.tecTitle }}</a
                      >
                      <div class="news-item-content">
                        <p style="margin:0 0 10px">{{ item.tecContent }}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col class="col-md-6 right-techpic" style="">
              <div style="margin-top: 0;margin-bottom: 0;">
                <b-img :src="tecBanner.src" fluid style="width: 100%;"></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div style="background:#ddd" class="p-3">
      <techLicense />
    </div>
    <footbanner />
  </div>
</template>

<style>
@import url("../assets/css/iconfont.css");
@import url("../assets/css/anim.css");
@import url("../assets/css/base.css");
</style>
<style scoped>
/* .container h2{
        visibility: hidden;
        animation: top-bottom 1s linear forwards;
    } */
@media (max-width: 768px) {
  #arr {
    display: none !important;
  }
}
#arr {
  display: block;
  opacity: 0;
}
#arr span {
  width: 65px;
  height: 120px;
  position: absolute;
  left: 30px;
  top: 50%;
  margin-top: -20px;
  background: #666;
  cursor: pointer;
  line-height: 120px;
  text-align: center;
  font-weight: bold;
  font-family: "黑体";
  font-size: 30px;
  color: #fff;
  opacity: 0.7;
  border: 1px solid #999;
}
#arr #right {
  right: 30px;
  left: auto;
}

.grid {
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.grid .cell.is-6 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
}
.grid .cell {
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 0 10px;
}
.grid-slider {
  position: relative;
  width: 100%;
  height: 660px;
  display: block;
  z-index: 400;
}

.halfswiper .carousel-item {
  max-height: 405px !important;
}
@media (max-width: 768px) {
  .halfswiper .carousel-item {
    min-height: 205px !important;
  }
  .left-carousel {
    padding-right: 0px !important;
  }
}

/* .pro-col:nth-child(1) img:nth-child(1):hover{
    transition: rotateZ(360deg) 1s ease-in
  } */

.proHomecontainer {
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.newstec {
  height: 900px;
}
@media (min-width: 768px) {
  .proHomecontainer {
    /* max-width: 1440px; */
  }
  .left-newspic {
    flex-basis: auto !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .right-techpic {
    flex-basis: auto !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}
</style>
<script>
/* eslint-disable no-unused-vars */
import { postRequest, postJsonRequest } from "../main";
import techLicense from "../components/home/techLicense/techLicense";
import footbanner from "./footbanner.vue";
import productBanner from "../components/home/product/productBanner";
import mySwiper from "../components/swiper/mySwiper";
export default {
  components: {
    techLicense,
    footbanner,
    productBanner,
    mySwiper,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      cur_page: 1,
      //  picurl:"http://imgs.dota4.cn"
      Proimg: [],
      news: [],
      tech: [],
      newsBanner: { src: require("../../static/Updatedimg/Tech&News.jpg") },
      tecBanner: { src: require("../../static/Updatedimg/swiper-1.jpg") },
      aboutBanner: { src: require("../../static/Updatedimg/Corp-home.png") },

      num: 0,
      time: "",
    };
  },
  methods: {
    jump(id, title, detail, bigimg) {
      // console.log(title)
      // this.$router.push(`prodetail/${id}`)
      this.$router.push({
        path: `/prodetail/${id}`,
        query: {
          title: title,
          id: id,
          detail: detail,
          bigimg: bigimg,
        },
      });
      // this.$router.push('/desc');
    },

    getNews() {
      postRequest("http://houtai.pioneertools.com/public/getAllNews", {
        page: this.cur_page,
      }).then((res) => {
        let data = res.data.data.list;
        let HomeNews = [];
        let len = data.length < 3 ? data.length : 3;
        for (let i = 0; i < len; i++) {
          let d = new Date(data[i].newsTime);
          data[i].day = d.getDate();
          data[i].ym = d.getFullYear() + "-" + d.getMonth();
          HomeNews[i] = data[i];
          // console.log(HomeNews[i]);
        }
        this.news = HomeNews;
        //  this.total=res.data.data.total;
      });
    },
    getTech() {
      postRequest("http://houtai.pioneertools.com/public/selectAllTec", {
        page: this.cur_page,
      }).then((res) => {
        // console.log(res);
        let data = res.data.data.list;
        let HomeTech = [];
        let len = data.length < 3 ? data.length : 3;
        for (let i = 0; i < len; i++) {
          let d = new Date(data[i].tecTime);
          data[i].day = d.getDate();
          data[i].ym = d.getFullYear() + "-" + d.getMonth();
          HomeTech[i] = data[i]; // data[i].tecContent = data[i].tecContent.substring(0,20)+"..."
        }
        this.tech = HomeTech;
      });
    },

    // this.$router.push('/desc');
  },
  created() {
    this.getNews();
    // this.getproducts()
    this.getTech();
  },
  mounted() {},
};
</script>
